module.exports = "<ol class=\"breadcrumb\" id=\"breadcrumb-nav\">\n  <li class=\"breadcrumb-step\">\n    <a href=\"/\">Home</a>\n  </li>\n</ol>"